import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
    allSeries: [],
    allVersions: [],
    firstItem: {},
    secondItem: {},
    thirdItem: {},
    firstSpecifications: [],
    secondSpecifications: [],
    thirdSpecifications: [],
    allItems: [],
    features: ['all'],
    specifications: [],
    differences: false,
}

export const getSeries = createAsyncThunk('modelsComparator/getSeries', async (locale, thunkAPI) => {
    try {
        const response = await axios.get('/api/vehicles/series/', {
            headers: {
                'Accept-Language': locale
            }
        })

        const order = ['Especificaciones técnicas', 'Exterior', 'Interior', 'Seguridad'];

        const sortedData = response.data.map((serie) => {
            serie.versions.forEach((version) => {
                version.specifications.sort((a, b) => {
                    return order.indexOf(a.parent_name) - order.indexOf(b.parent_name);
                });
            });
            return serie;
        });

        // console.log(sortedData);
        return sortedData;
    } catch (error) {
        console.log(error);
    };
})

export const modelsComparatorSlice = createSlice({
    name: 'modelsComparator',
    initialState,
    reducers: {
        setFirstItem(state, action) {
            action.payload.id !== state.secondItem.id && action.payload.id !== state.thirdItem.id ?
                state.firstItem = action.payload
                : state.firstItem = {}

            state.allItems = [state.firstItem, state.secondItem, state.thirdItem]
        },
        setSecondItem(state, action) {
            action.payload.id !== state.firstItem.id && action.payload.id !== state.thirdItem.id ?
                state.secondItem = action.payload
                : state.secondItem = {}

            state.allItems = [state.firstItem, state.secondItem, state.thirdItem]
        },
        setThirdItem(state, action) {
            action.payload.id !== state.firstItem.id && action.payload.id !== state.secondItem.id ?
                state.thirdItem = action.payload
                : state.thirdItem = {}

            state.allItems = [state.firstItem, state.secondItem, state.thirdItem]
        },
        setAllSpecifications(state, action) {
            const spec = state.firstItem?.specifications?.map(obj => obj.parent_name)
            const spec2 = state.secondItem?.specifications?.map(obj => obj.parent_name)
            const spec3 = state.thirdItem?.specifications?.map(obj => obj.parent_name)
            state.specifications = [...new Set(spec?.concat(spec2, spec3))]
        },
        setVisibleFeatures(state, action) {
            const index = state.features.findIndex(e => e === action.payload)

            if (index !== -1) {
                state.features.splice(index, 1)
            } else {
                state.features.push(action.payload)
                state.features = [...new Set(state.features)];
                state.features = state.features.filter(e => e !== 'all')
            }

            if (action.payload === 'all') {
                state.features = ['all']
                return
            }
        },
        setDifferences(state, action) {
            state.differences = true

            function removeDuplicateSpecifications(item, items) {
                const specifications = item.specifications;
                const duplicateSpecifications = [];

                if (specifications) {
                    for (let i = 0; i < specifications.length; i++) {
                        const currentSpecification = specifications[i];

                        for (let j = 0; j < items.length; j++) {
                            const currentItem = items[j];

                            if (currentItem.id === item.id) {
                                continue;
                            }

                            const itemSpecifications = currentItem.specifications;

                            if (itemSpecifications) {
                                for (let k = 0; k < itemSpecifications.length; k++) {
                                    const currentComparisonSpecification = itemSpecifications[k];

                                    if (
                                        currentComparisonSpecification.parent_name === currentSpecification.parent_name &&
                                        currentComparisonSpecification.specification_name === currentSpecification.specification_name &&
                                        currentComparisonSpecification.value === currentSpecification.value
                                    ) {
                                        duplicateSpecifications.push(currentSpecification);
                                    }
                                }
                            }
                        }
                    }
                }

                const uniqueSpecifications = specifications?.filter((specification) => {
                    return !duplicateSpecifications.some((duplicate) => {
                        return (
                            duplicate.parent_name === specification.parent_name &&
                            duplicate.specification_name === specification.specification_name &&
                            duplicate.value === specification.value
                        );
                    });
                });


                return { ...item, specifications: uniqueSpecifications };
            }

            state.firstSpecifications = removeDuplicateSpecifications(state.firstItem, [state.secondItem, state.thirdItem]).specifications;
            state.secondSpecifications = removeDuplicateSpecifications(state.secondItem, [state.firstItem, state.thirdItem]).specifications;
            state.thirdSpecifications = removeDuplicateSpecifications(state.thirdItem, [state.firstItem, state.secondItem]).specifications;
        },
        setDifferencesOff(state, action) {
            state.differences = false
        }
    },

    extraReducers: {
        [getSeries.fulfilled]: (state, action) => {
            state.allSeries = action.payload
            const versions = state.allSeries.map(obj => obj.versions)
            state.allVersions = state.allVersions.concat(...versions)
        }
    }
})

// Action creators are generated for each case reducer function
export const {
    setFirstItem,
    setSecondItem,
    setThirdItem,
    setVisibleFeatures,
    setAllSpecifications,
    setDifferences,
    setDifferencesOff
} = modelsComparatorSlice.actions

export default modelsComparatorSlice.reducer
